import { axiosInstance } from 'api/instance';
import { alertEndpoints } from './alert.endpoints';

const deleteAlert = (id, crop_pipeline, check_type, field, threshold) =>
  axiosInstance.post(alertEndpoints.delete_alert(id), {
    params: {
      crop_pipeline: crop_pipeline,
      check_type: check_type,
      field: field,
      threshold: threshold
    }
  });
const createAlert = (customer, locationId, crop_pipeline, check_type, field, threshold) =>
  axiosInstance.post(alertEndpoints.create_alert(customer, locationId), {
    params: {
      crop_pipeline: crop_pipeline,
      check_type: check_type,
      field: field,
      threshold: threshold
    }
  });
const updateAlert = (id, crop_pipeline, check_type, field, threshold) =>
  axiosInstance.patch(alertEndpoints.update_alert(id), {
    params: {
      crop_pipeline: crop_pipeline,
      check_type: check_type,
      field: field,
      threshold: threshold
    }
  });
const getAlerts = (customer, locationId) =>
  axiosInstance.get(alertEndpoints.get_alerts(customer), {
    params: {
      location: locationId
    }
  });
const getAlertLogsCount = customer =>
  axiosInstance.get(alertEndpoints.get_alert_logs_count(customer));
const getAlertLogs = (customer, locationId, start, end, page) =>
  axiosInstance.get(alertEndpoints.get_alert_logs(customer), {
    params: {
      location: locationId,
      start: start,
      end: end,
      page: page
    }
  });
const markAlertAsViewed = uuid =>
  axiosInstance.post(alertEndpoints.mark_alert_as_viewed(uuid));
export const alertRequests = {
  deleteAlert,
  createAlert,
  updateAlert,
  getAlerts,
  getAlertLogsCount,
  getAlertLogs,
  markAlertAsViewed
};
